import { useCallback } from 'react';
import moment from 'moment';

// import LeadActivityIcon from '../../assets/icons/LeadActivityIcon';
import PipelineIcon from '../../assets/icons/PipelineIcon';
import CallIcon from '../../assets/icons/CallIcon';
import MeetingIcon from '../../assets/icons/MeetingIcon';
import TrainingIcon from '../../assets/icons/TrainingIcon';
import DemoIcon from '../../assets/icons/DemoIcon';
import EditIcon from '../../assets/icons/EditIcon';

import LeadActivityForm from './LeadActivityForm';

import { leadActivityCategories, leadActivityDurationOptions } from '../../constants/sales';

import './leads.scss';


const LeadActivity = (props) => {
  const {
    activity = [],
    users = [],
    addActivityMode,
    onCancel,
    onAddActivity,
    loading,
    currentUserId,
    selectedActivity,
    onEditClick,
  } = props;

  const getUserName = useCallback((uid) => {
    const user = users.find((u) => u.uid === uid);
    return user ? `${user.firstName} ${user.lastName}` : '';
  }, [users]);

  const getIcon = useCallback((activity) => {
    switch (activity.category) {
      case leadActivityCategories.ACTIVITY.value:
        return <PipelineIcon color="var(--app-text)" />;
      case leadActivityCategories.CALL.value:
        return <CallIcon color="var(--app-text)" />;
      case leadActivityCategories.MEETING.value:
        return <MeetingIcon color="var(--app-text)" />;
      case leadActivityCategories.TRAINING.value:
        return <TrainingIcon color="var(--app-text)" />;
      case leadActivityCategories.DEMO.value:
        return <DemoIcon color="var(--app-text)" />;
      default:
        return <PipelineIcon color="var(--app-text)" />;
    }
  }, []);

  const getTitle = useCallback((activity) => {
    switch (activity.category) {
      case leadActivityCategories.ACTIVITY.value:
        return leadActivityCategories.ACTIVITY.label;
      case leadActivityCategories.CALL.value:
        return leadActivityCategories.CALL.label;
      case leadActivityCategories.MEETING.value:
        return leadActivityCategories.MEETING.label;
      case leadActivityCategories.TRAINING.value:
        return leadActivityCategories.TRAINING.label;
      case leadActivityCategories.DEMO.value:
        return leadActivityCategories.DEMO.label;
      default:
        return leadActivityCategories.ACTIVITY.label;
    }
  }, []);


  return (
    <div className="lead-activity__container">
      {addActivityMode && (
        <LeadActivityForm
          onCancel={onCancel}
          onSubmit={onAddActivity}
          loading={loading}
          initialValue={selectedActivity}
          submitText={selectedActivity ? 'Save Changes' : 'Submit'}
        />
      )}
      <div className='lead-activity__activity-items-list'>
        {activity?.length ? (
          activity?.map((item) => (
            <div key={item.id} className='lead-activity__activity-item'>
              <div className='d-flex space-between'>
                <div className='d-flex'>
                  {getIcon(item)}
                  <div className='font-bold m-l-md'>{getTitle(item)}</div>
                  <div className='m-l-sm font-size-sm'>by {getUserName(item.userId)}</div>
                </div>
                <div className='d-flex' style={{ alignItems: 'center' }}>
                  <div className='font-size-sm secondary'>
                    {moment(item.createdAt).format('Do MMMM YYYY, HH:mm a')}
                  </div>
                  {currentUserId === item.userId && (
                    <div className='pointer m-l-md' onClick={() => onEditClick(item)}>
                      <EditIcon fontSize='small' color="var(--app-text)" />
                    </div>
                  )}
                </div>
              </div>
              {item?.category !== leadActivityCategories.ACTIVITY && item?.bookingData && (
                <div className='m-t-md'>
                  <div className='secondary'>
                    {`${moment(item.bookingData?.date).format('Do MMMM YYYY, HH:mm a')} (${leadActivityDurationOptions[item?.bookingData?.duration]?.label || ''})`}
                  </div>
                </div>
              )}
              <div className='m-t-md font-bold'>
                {item.title}
              </div>
              <div className='m-t-sm'>
                {item.payload}
              </div>
            </div>
          ))
        ) : (
          <div className='p-lg font-size-bg font-bold secondary d-flex flex-center'>
            No Activity
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadActivity;
